import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersInsightPostsAiCommentRequestsMutateResponseType } from "~/domains";

type RequestDataType = {
  insightPostId: string;
};

const request = ({ insightPostId }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersInsightPostsAiCommentRequestsMutateResponseType>(
      `/api/members/insight_posts/${insightPostId}/ai_comment_requests`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisInsightPostsAiCommentRequestsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersInsightPostsAiCommentRequestsMutateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
